import { Paper, Tooltip, TooltipProps, Typography, styled, tooltipClasses } from '@mui/material'
import { ReactElement } from 'react';

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    margin: 0,
    padding: 0,
  },
}));

export const TooltipHover: React.FC<{
  text: string,
  placement: any,
  children: ReactElement,
  backgroundColor: string,
  email?: string,
  title?: string,
  textColor?: string,
}> = ({ 
  text, 
  placement, 
  children, 
  backgroundColor, 
  email, 
  title, 
  textColor }) => {

  return (
    <StyledTooltip
      title={
        <Paper sx={{ p: 1, backgroundColor: backgroundColor }} elevation={3}>
          {title && <Typography variant='subtitle1' color='primary.main' sx={{ fontWeight: 600, pb: 1 }}>{title}</Typography>}
          <Typography variant='body2' sx={{ color: textColor ? textColor : 'text.primary', fontWeight: 400 }}>
            {text}
          </Typography>
          {email &&
            <a href={`mailto:${email}`} style={{ textDecoration: 'none' }}>
              <Typography variant="body1" sx={{ color: 'primary.dark', fontWeight: 400, textDecoration: 'underline', mt: 1 }}>
                {email}
              </Typography>
            </a>
          }
        </Paper>
      }
      placement={placement}
    >{children}
    </StyledTooltip>
  )
}